import { SelectionModel } from '@angular/cdk/collections';
import { FlatTreeControl } from '@angular/cdk/tree';
import { Component, EventEmitter, Injectable, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { BehaviorSubject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
/**
 * Node for to-do item
 */
export class TreeItemNode {
  children!: TreeItemNode[];
  item!: string;
  code!: string;
  color!: string;
  id!: string;
  isChecked!: boolean;
}

/** Flat to-do item node with expandable and level information */
export class TreeItemFlatNode {
  item!: string;
  level!: number;
  expandable!: boolean;
  code!: string;
  color!: string;
  id!: string;
  isChecked!: boolean;
}

/**
 * The Json object for to-do list data.
 */
const TREE_DATA = [
  { 'text': 'SOUTHWEST DIVISION', 'code': '0.1', 'isChecked': false, 'id': 'R1', 'color': '#4F528C'},
  { 'text': 'NEWPORT BEACH CA', 'code': '0.1.1', 'isChecked': false, 'id': 'R1', 'color': '#5c60b7'},
  { 'text': 'Bill Management', 'code': '0.1.1' },
  { 'text': 'Allow Bill Export Images', 'code': '0.1.1.1' },
  { 'text': 'Unassigned Queue Access', 'code': '0.1.1.1' },
  { 'text': 'Work Queue Access', 'code': '0.1.1.1' },

  { 'text': 'Bill Management Actions', 'code': '0.1.2' },
  { 'text': 'Allow Mark as Review Only', 'code': '0.1.2.1' },
  { 'text': 'Allow Pay Code Edits', 'code': '0.1.2.1' },

  { 'text': 'Claims', 'code': '0.1.3' },
  { 'text': 'Allow Export: Bill Review Log', 'code': '0.1.3.1' },
  { 'text': 'Allow Export: Claim History', 'code': '0.1.3.2' },
  { 'text': 'Allow Export: Related Bill Summary', 'code': '0.1.3.3' },
  { 'text': 'Claims Management', 'code': '0.1.3.4' },
  { 'text': 'My Downloads', 'code': '0.1.3.5' },

  { 'text': 'FA', 'code': '0.2' },
  { 'text': 'Bill Management', 'code': '0.2.1' },
  { 'text': 'Allow Bill Export Images', 'code': '0.2.1.1' },
  { 'text': 'Unassigned Queue Access', 'code': '0.2.1.1' },
  { 'text': 'Work Queue Access', 'code': '0.2.1.1' },

  { 'text': 'Bill Management Actions', 'code': '0.2.2' },
  { 'text': 'Allow Mark as Review Only', 'code': '0.2.2.1' },
  { 'text': 'Allow Pay Code Edits', 'code': '0.2.2.1' },

  { 'text': 'Claims', 'code': '0.2.3' },
  { 'text': 'Allow Export: Bill Review Log', 'code': '0.2.3.1' },
  { 'text': 'Allow Export: Claim History', 'code': '0.2.3.2' },
  { 'text': 'Allow Export: Related Bill Summary', 'code': '0.2.3.3' },
  { 'text': 'Claims Management', 'code': '0.2.3.4' },
  { 'text': 'My Downloads', 'code': '0.2.3.5' }


  
];

/**
 * Checklist database, it can build a tree structured Json object.
 * Each node in Json object represents a to-do item or a category.
 * If a node is a category, it has children items and new items can be added under the category.
 */
@Injectable()
export class ChecklistDatabase {
  dataChange = new BehaviorSubject<TreeItemNode[]>([]);
  treeData!: any[];
  get data(): TreeItemNode[] { return this.dataChange.value; }

  constructor() {
    //this.initialize();
  }

  initialize(TREE_DATA: any) {
    this.treeData = TREE_DATA;
    // Build the tree nodes from Json object. The result is a list of `TodoItemNode` with nested
    //     file node as children.
    const data = this.buildFileTree(TREE_DATA, '0');
    // Notify the change.
    this.dataChange.next(data);
  }

  /**
   * Build the file structure tree. The `value` is the Json object, or a sub-tree of a Json object.
   * The return value is the list of `TodoItemNode`.
   */

  buildFileTree(obj: any[], level: string): TreeItemNode[] {
    return obj.filter(o =>
      (<string>o.code).startsWith(level + '.')
      && (o.code.match(/\./g) || []).length === (level.match(/\./g) || []).length + 1
    )
      .map(o => {
        const node = new TreeItemNode();
        node.item = o.text;
        node.code = o.code;
        node.color = o.color;
        node.id = o.id;
        node.isChecked = o.isChecked;

        const children = obj.filter(so => (<string>so.code).startsWith(level + '.'));
        if (children && children.length > 0) {
          node.children = this.buildFileTree(children, o.code);
        }
        return node;
      });
  }

  public filter(filterText: string) {
    let filteredTreeData: any;
    if (filterText) {
      console.log(this.treeData);
      filteredTreeData = this.treeData.filter(d => d.text.toLocaleLowerCase().indexOf(filterText.toLocaleLowerCase()) > -1);
      Object.assign([], filteredTreeData).forEach((ftd: any) => {
        let str = (<string>ftd.code);
        while (str.lastIndexOf('.') > -1) {
          const index = str.lastIndexOf('.');
          str = str.substring(0, index);
          if (filteredTreeData.findIndex((t: any) => t.code === str) === -1) {
            const obj = this.treeData.find(d => d.code === str);
            if (obj) {
              filteredTreeData.push(obj);
            }
          }
        }
      });
    } else {
      filteredTreeData = this.treeData;
    }

    // Build the tree nodes from Json object. The result is a list of `TodoItemNode` with nested
    // file node as children.
    const data = this.buildFileTree(filteredTreeData, '0');
    // Notify the change.
    this.dataChange.next(data);
  }
}

/**
 * @title Tree with checkboxes
 */
@Component({
  selector: 'app-advisors-tree-filter',
  templateUrl: 'advisors-tree-filter.component.html',
  styleUrls: ['advisors-tree-filter.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [ChecklistDatabase]
})
export class AdvisorsTreeFilterComponent implements OnInit {

  @Input('AdvisorsTreeData')
  advisorsTreeData!: any[];
  @Input('SelectedRepIds') selectedRep!: string[];
  @Output() OnAppliedFilter: EventEmitter<string[]> = new EventEmitter();
  @Output() cancelFilter: EventEmitter<any> = new EventEmitter();
  searchControl = new FormControl('', [Validators.maxLength(12)]);
  firstTimeLoad = false;

  /** Map from flat node to nested node. This helps us finding the nested node to be modified */
  flatNodeMap = new Map<TreeItemFlatNode, TreeItemNode>();

  /** Map from nested node to flattened node. This helps us to keep the same object for selection */
  nestedNodeMap = new Map<TreeItemNode, TreeItemFlatNode>();

  /** A selected parent node to be inserted */
  selectedParent: TreeItemFlatNode | null = null;

  /** The new item's name */
  newItemName = '';

  treeControl!: FlatTreeControl<TreeItemFlatNode>;

  treeFlattener!: MatTreeFlattener<TreeItemNode, TreeItemFlatNode>;

  dataSource!: MatTreeFlatDataSource<TreeItemNode, TreeItemFlatNode>;

  /** The selection for checklist */
  checklistSelection = new SelectionModel<TreeItemFlatNode>(true /* multiple */);
  
  constructor(private database: ChecklistDatabase) {   
  }

  ngOnInit(): void {  
    this.searchControl.valueChanges
    .pipe(
      debounceTime(500)
    ).subscribe (
      (searchText: any) => {
          this.filterChanged(searchText);
      }
    );
    
    this.database.initialize(this.advisorsTreeData);
    this.treeFlattener = new MatTreeFlattener(this.transformer, this.getLevel,this.isExpandable, this.getChildren);
    this.treeControl = new FlatTreeControl<TreeItemFlatNode>(this.getLevel, this.isExpandable);
    this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

    this.database.dataChange.subscribe(data => {
      this.dataSource.data = data;
      if(!this.firstTimeLoad){
        this.firstTimeLoad = true;
        this.populateSelection();        
      }      
    });
  }

  populateSelection(){    
    if(this.selectedRep && this.selectedRep.length){
      for (let i = 0; i < this.treeControl.dataNodes.length; i++) {
        if(this.selectedRep.includes(this.treeControl.dataNodes[i].id))
        this.checklistSelection.toggle(this.treeControl.dataNodes[i]);
      }
    }
    else
    {
      for (let i = 0; i < this.treeControl.dataNodes.length; i++) {
        if(this.treeControl.dataNodes[i].isChecked){
          this.checklistSelection.toggle(this.treeControl.dataNodes[i]);
        }          
      }        
    }    
  }

  getLevel = (node: TreeItemFlatNode) => node.level;

  isExpandable = (node: TreeItemFlatNode) => node.expandable;

  getChildren = (node: TreeItemNode): TreeItemNode[] => node.children;

  hasChild = (_: number, _nodeData: TreeItemFlatNode) => _nodeData.expandable;

  hasNoContent = (_: number, _nodeData: TreeItemFlatNode) => _nodeData.item === '';

  /**
   * Transformer to convert nested node to flat node. Record the nodes in maps for later use.
   */
  transformer = (node: TreeItemNode, level: number) => {
    const existingNode = this.nestedNodeMap.get(node);
    const flatNode = existingNode && existingNode.item === node.item
      ? existingNode
      : new TreeItemFlatNode();
    flatNode.item = node.item;
    flatNode.level = level;
    flatNode.code = node.code;
    flatNode.color = node.color;
    flatNode.id = node.id;
    flatNode.isChecked = node.isChecked;    
    flatNode.expandable = node.children && node.children.length > 0;
    this.flatNodeMap.set(flatNode, node);
    this.nestedNodeMap.set(node, flatNode);
    return flatNode;
  }

  /** Whether all the descendants of the node are selected */
  descendantsAllSelected(node: TreeItemFlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    return descendants.every(child => this.checklistSelection.isSelected(child));
  }

  /** Whether part of the descendants are selected */
  descendantsPartiallySelected(node: TreeItemFlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    const result = descendants.some(child => this.checklistSelection.isSelected(child));
    return result && !this.descendantsAllSelected(node);
  }
  
  /** Toggle the to-do item selection. Select/deselect all the descendants node */
  todoItemSelectionToggle(node: TreeItemFlatNode): void {
    this.checklistSelection.toggle(node);
    const descendants = this.treeControl.getDescendants(node);
    this.checklistSelection.isSelected(node)
      ? this.checklistSelection.select(...descendants)
      : this.checklistSelection.deselect(...descendants);
  }
   
  filterChanged(filterText: string) {
    this.database.filter(filterText);
    if(filterText)
    {
      this.treeControl.expandAll();
    } else {
      this.treeControl.collapseAll();
      // this.treeControl.expandAll();
    }
  }

  applyFilter(){      
    //if(this.checklistSelection.selected.length){
      let _selectedReps:string[] = [];
      (this.checklistSelection.selected.filter(t => !t.expandable) || []).forEach(x => {
        _selectedReps.push(x.id);
        //console.log(x);
      });
      // if(_selectedReps.length){
        
        this.OnAppliedFilter.emit(_selectedReps);
        console.log(_selectedReps);
      // }      
    //}    
  }

  clearFilter(){
    this.searchControl.setValue('');
   // this.filterChanged('');
    for (let i = 0; i < this.treeControl.dataNodes.length; i++) {
      if(this.selectedRep.includes(this.treeControl.dataNodes[i].id))
        this.checklistSelection.toggle(this.treeControl.dataNodes[i]);
    }
  }
  cancel(){
    this.cancelFilter.emit(null);    
  }
}